module.exports = __webpack_public_path__ + "media/images/el_lenguaje_de_hoy-8d8e2d7c9de0adf852c5f60ab28ba27d.jpg";